module.exports = __webpack_public_path__ + "img/element-3.aa86d759.svg";